var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "team-box" }, [
    _vm._m(0),
    _c("div", [
      _c("div", { staticClass: "content-right-box" }, [
        _c("div", [
          _vm._m(1),
          _c("div", { staticClass: "text-box" }, [
            _c("div", { staticClass: "text-top" }, [
              _c("span", { staticClass: "font-title" }, [
                _vm._v(
                  _vm._s(
                    _vm.planData.totalScore
                      ? Number(_vm.planData.totalScore).toFixed(2)
                      : "0"
                  )
                ),
              ]),
            ]),
            _c("span", { staticClass: "font-status" }, [
              _vm._v(" " + _vm._s(_vm.$t("showLxRecordStudent.ZF")) + " "),
            ]),
          ]),
        ]),
      ]),
      _c(
        "p",
        {
          directives: [
            {
              name: "auth",
              rawName: "v-auth",
              value: [["teacher", "student"], "pro"],
              expression: "[['teacher', 'student'], 'pro']",
            },
            {
              name: "show",
              rawName: "v-show",
              value: _vm.queryData.pattern_lx != 2,
              expression: "queryData.pattern_lx != 2",
            },
          ],
        },
        [
          _c("el-tag", { attrs: { size: "mini" } }, [
            _vm._v(" " + _vm._s(_vm.$t("showLxRecordStudent.SSBJ")) + " "),
          ]),
          _c("span", { staticClass: "team-name" }, [
            _vm._v(
              _vm._s(
                _vm.planData.playerDto.className
                  ? _vm.planData.playerDto.className
                  : "-"
              )
            ),
          ]),
        ],
        1
      ),
      _c(
        "p",
        [
          _c("el-tag", { attrs: { size: "mini" } }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("showLxRecordStudent.X")) +
                "       " +
                _vm._s(_vm.$t("showLxRecordStudent.M")) +
                " "
            ),
          ]),
          _c("span", { staticClass: "leader-name nowrap" }, [
            _vm._v(" " + _vm._s(_vm.planData.playerDto.playerName) + " "),
          ]),
        ],
        1
      ),
      _c(
        "p",
        [
          _c("el-tag", { attrs: { size: "mini" } }, [
            _vm._v(" " + _vm._s(_vm.$t("showLxRecordStudent.LXSJ")) + " "),
          ]),
          _vm.planData.practiseLog
            ? _c("span", { staticClass: "status-text nowrap" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.planData.practiseLog.startTime) +
                    " -- " +
                    _vm._s(_vm.planData.practiseLog.submitTime) +
                    " "
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "image-box" }, [
      _c("img", { attrs: { src: require("@/assets/image/ren.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-box" }, [
      _c("img", { attrs: { src: require("@/assets/image/jiaojuan.png") } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }